module.exports = __webpack_public_path__ + "media/fonts/SFProText-Regular-4694bfca311059dbd8a5d2c37ba6dcef.eot";